import { useContext } from 'react';
import PortfolioItemContext from '../../../../PortfolioItemContext';
import FieldContext from '../../FieldContext';
import { type DatabaseExternalFile } from '@/lib/types';

const useFieldExternalFiles = (): DatabaseExternalFile[] => {
  const { portfolioItem } = useContext(PortfolioItemContext);
  const field = useContext(FieldContext);

  const fieldValue = portfolioItem.fieldValues[field.id];

  if (typeof fieldValue === 'undefined') {
    return [];
  }

  return Object.values(fieldValue.externalFiles);
};

export default useFieldExternalFiles;
